import Vue from "vue";
import Vuex from "vuex";

import auth from "@/store/modules/auth";
import global from "@/store/modules/global";
import locationsModule from "@/store/modules/locations";
import EventObject from "@/objects/EventObject";
import appConfig from "../config/app_config";
import VuexPersist from 'vuex-persist';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'my-app',
  storage: localStorage
})

export const store = new Vuex.Store({
  // plugins: [vuexPersist.plugin],
  /**
   * it specifies exclusively the module 'auth' to be persistent across refresh and cache clean
   * the module 'auth' contains all the user login/tags information only
   */
  plugins: [
    createPersistedState({
      paths: ['auth']
    }),
  ],
  modules: {
    auth,
    global,
    locationsModule,
  },
  state: {
    eventIdForProductCalendar: '',
    productIdForProductCalendar: '',
    goToAfterLoginOrRegister: '',
    newLocationList: [],
    centerPointForMap: [],
    routeEvents: [],
    calendarOnHomePage: {},
    userIsInQuadrantScreen: true,
    backupDataForRouteAspect: {},
    userIsCreatingEvent: false,
    allVisibleLocations: [],
    mainLocationAspects: {},
    userIsCrowdScout: false,
    titleOfMap: '',
    timeMarkers: {},
    deliverMarkers: {},
    allDelivers: {},
    userActivatedSuccessfull: false,
    enlargedQuadrant: false,
    quadrantEvent: {},
    selectedTheme: {},
    userGoesBackToHomepage: false,
    eventSave:'',
    partnerCreate: false,
    selectedDate: '',
    stampsDialog: false,
    seeMapInOprMapQua: false,
    shoppingCart: {},
    clickedOnPasspoortButton: false,
    addUserAccommodations: false,
    qrCodeScanner: false,
    amountEuros: "",
    redirectedFromWebToEvent: false,
    browserType: "",
    showButton: true,
    userOrderLon: "",
    userOrderLat: "",
    activitiesForLocation: [],
    noBackground: false,
    refForHomepage: "",
    themes: [],
    userIsCreatingPassport: false,
    currentScrollPos: 0,
    userTripOverview: {
      orderList: {}
    },
    tours: {},
    clickedTime: {},
    locationsOfUserTripList: {},
    locationDetails:{},
    selectedEventId: '',
    listOfFavourites: {},
    saveFavourite: {},
    bookingData: {},
    adminData: {},
    goToPartnerAccount: false,
    rememberAccountPassword: {},
    filtersForEvent: {},
    calendar: {},
    calendarIsEmpty: true,
    eventDetailsSaved: {},
    themeListEventId: 0,
    ABCMapMarker: "",
    CategorieMarkers: "",
    ActivitiesMarker: "",
    DrinkingMarker: "",
    EatingMarker: "",
    MapMarkerPin: "",
    chosenLocationId: {},
    allRoutes: {},
    selectedItem: null,
    chosenEvent: {},
    savePartnerId: "",
    noBackendConnection: false,
    redirectedFromPearlCalendar: false,
    visitorActive: false,
    userCalendarCache: {},
    chosenLocationId: "",
    userLocations: {},
    userNotInAccount: false,
    currentComponent: "",
    currentMainComponent: "",
    userGroupsForAccount: [],
    discountCards: [],
    AccountInfo: {
      AccountDescription: "",
      AccountId: "",
      AccountName: "",
      CompanyName: "",
      CompanyAddress: "",
      CompanyEmail: "",
      CompanyName: "",
      CompanyWebsite: "",
      CreationDate: null,
      AdministrationNr: null,
      AdministrationNrFee: null,
      ExpirationDate: null,
      Link: "",
      MemberTagId: null,
      State: "",
    },
    AccountVat: {},
    customerPreferencesObjects: {
      Primary_color: "",
      Secondary_color: "",
      Font_properties: "",
      Background_image: "",
      Header_logo: "",
      Name: "",
      mobile_image: "",
    },
    customerPreferences: {
      Primary_color: "",
      Secondary_color: "",
      Font_properties: "",
      Header_logo: "",
      Name: "",
      mobile_image: "",
    },
    Background_image: "",
    tripForm: {
      name: "",
      ignoreWarning: false,
      mainEventId: null,
      eventName: "",
      locationId: "",
      orderId: "",
      date: "",
      specialCode: "",
      groupSize: null,
      ArrivalTime: "",
      DepartureTime: "",
      activityList: {},
      chosenActivities: "",
      transportId: null,
      transportName: "",
      totalPrice: null,
      orderEvents: {},
      paymentId: "",
      chosenChildren: {},
      chosenTheme: {},
      issueList: {},
    },
    draggedElement: "",
    dragStatus: 0,
    // dropStatus: 0,
    dashboardStatus: 0,
    count: 0,
    ADS: false,
    MAS: false,
    // uniqueId: "",
    stepId: 0,
    webStepId: 0,
    paymentId: "",
    language: "EN", //'EN'
    userLanguage: "",
    languages: [],
    mobilePhoneActive: false,
    eventData: [],
    currentEventId: "",
    arrivalInfo: [],
    orderId: "",
    subEventData: [],
    subEventSelected: [],
    totalPrice: [],
    orderBill: [],
    mainSelected: "",
    userEventArrivalData: [],
    mainEventId: "",
    subEventId: "",
    location: "",
    selectedEvents: [],
    selectedSubEvents: [],
    categories: [],
    selectedNotification: "",
    behaviour: 0,
    aspectsListRequested: false,
    incidents: [],
    anomalies: [],
    incidentsMap: new Map(),
    allObjectList: [],
    relationList: [],
    orderDetails: {},
    filtersTags: [],
    events: [],
    filterName: '',
    eventFilterName: '',
    sortLocationOrder: true,
    selectedPartOfLocation: {},
    allTags: [],
    mainLocationId: '',
    filtersForMap: {},
    filtersLocation: {},
    currentUserGroupId: {},
    accountId: '',
    currentAccountId: '',
    tabIdAccountManagement: 1,
    region: '',
    parentEventId: '',
    userActivationObject: {},
    operationalScreenSize: {
      w: 50,
      h: 50,
      r: 2,
      c: 3
    },
    UserRolesFromUserGroup: []
  },
  mutations: {
    setParentEventId(state, parentEventId){
      state.parentEventId = parentEventId;
    },
    setMainLocationId(state, mainLocationId){
      state.mainLocationId = mainLocationId;
    },
    setEventIdForCalendar(state, eventIdForProductCalendar){
      state.eventIdForProductCalendar = eventIdForProductCalendar;
    },
    setProductIdForCalendar(state, productIdForProductCalendar){
      state.productIdForProductCalendar = productIdForProductCalendar;
    },
    setFiltersForMap(state, filtersForMap){
      state.filtersForMap = filtersForMap;
    },
    setNewLocationList(state, newLocationList){
      state.newLocationList = newLocationList;
    },
    setGoToAfterLoginOrRegister(state, goToAfterLoginOrRegister){
      state.goToAfterLoginOrRegister = goToAfterLoginOrRegister;
    },
    setCenterPointForMap(state, centerPointForMap){
      state.centerPointForMap = centerPointForMap;
    },
    setRouteEvents(state, routeEvents){
      state.routeEvents = routeEvents;
    },
    setCalendarOnHomePage(state, calendarOnHomePage){
      state.calendarOnHomePage = calendarOnHomePage;
    },
    setUserIsInQuadrantScreen(state, userIsInQuadrantScreen){
      state.userIsInQuadrantScreen = userIsInQuadrantScreen;
    },
    setBackupDataForRouteAspect(state, backupDataForRouteAspect){
      state.backupDataForRouteAspect = backupDataForRouteAspect;
    },
    setUserIsCreatingEvent(state, userIsCreatingEvent){
      state.userIsCreatingEvent = userIsCreatingEvent;
    },
    setAllVisibleLocations(state, allVisibleLocations){
      state.allVisibleLocations = allVisibleLocations;
    },
    setMainLocationAspects(state, mainLocationAspects){
      state.mainLocationAspects = mainLocationAspects;
    },
    setUserIsCrowdScout(state, userIsCrowdScout){
      state.userIsCrowdScout = userIsCrowdScout;
    },
    setTitleOfMap(state, titleOfMap){
      state.titleOfMap = titleOfMap;
    },
    setTimeMarkers(state, timeMarkers) {
      state.timeMarkers = timeMarkers;
    },
    setDeliverMarkers(state, deliverMarkers) {
      state.deliverMarkers = deliverMarkers;
    },
    setAllDelivers(state, allDelivers) {
      state.allDelivers = allDelivers;
    },
    setUserActivationObject(state, userActivationObject) {
      state.userActivationObject = userActivationObject;
    },
    setUserActivatedSuccessfull(state, userActivatedSuccessfull) {
      state.userActivatedSuccessfull = userActivatedSuccessfull;
    },
    setTours(state, tours) {
      state.tours = tours;
    },
    setEventSave(state, eventSave) {
     state.eventSave = eventSave;
    },
    setQuadrantEvent(state, quadrantEvent) {
      state.quadrantEvent = quadrantEvent;
    },
    setEnlargedQuadrant(state, enlargedQuadrant) {
      state.enlargedQuadrant = enlargedQuadrant;
    },
    setADS(state, ADS) {
      state.ADS = ADS;
    },
    setMAS(state, MAS) {
      state.MAS = MAS;
    },
    setSelectedTheme(state, selectedTheme) {
      state.selectedTheme = selectedTheme;
    },
    setUserGoesBackToHomepage(state, userGoesBackToHomepage) {
      state.userGoesBackToHomepage = userGoesBackToHomepage;
    },
    setPartnerCreate(state, partnerCreate) {
      state.partnerCreate = partnerCreate;
    },
    setSelectedDate(state, selectedDate) {
      state.selectedDate = selectedDate;
    },
    setSeeMapInOprMapQua(state, seeMapInOprMapQua) {
      state.seeMapInOprMapQua = seeMapInOprMapQua;
    },
    setShoppingCart(state, shoppingCart) {
      state.shoppingCart = shoppingCart;
    },
    setCalendarIsEmpty(state, calendarIsEmpty) {
      state.calendarIsEmpty = calendarIsEmpty;
    },
    setClickedOnPasspoortButton(state, clickedOnPasspoortButton) {
      state.clickedOnPasspoortButton = clickedOnPasspoortButton;
    },
    setRegion(state, region) {
      state.region = region;
    },
    setRedirectedFromWebToEvent(state, redirectedFromWebToEvent){
      state.redirectedFromWebToEvent = redirectedFromWebToEvent;
    },
    setAddUserAccommodations(state, addUserAccommodations){
      state.addUserAccommodations = addUserAccommodations;
    },
    setQrCodeScanner(state, qrCodeScanner){
      state.qrCodeScanner = qrCodeScanner;
    },
    setStampsDialog(state, stampsDialog){
      state.stampsDialog = stampsDialog
    },
    setAmountEuros(state, amountEuros){
      state.amountEuros = amountEuros;
    },
    setBrowserType(state, browserType){
      state.browserType = browserType;
    },
    setShowButton(state, showButton){
      state.showButton = showButton;
    },
    setAccountId(state, accountId){
      state.accontId = accountId;
    },
    setClickedTime(state, clickedTime){
      state.clickedTime = clickedTime;
    },
    setActivitiesForLocation(state, activitiesForLocation){
      state.activitiesForLocation = activitiesForLocation;
    },
    setLocationsOfUserTripList(state, locationsOfUserTripList){
      state.locationsOfUserTripList = locationsOfUserTripList;
    },
    setLocationDetails(state, locationDetails){
      state.locationDetails = locationDetails;
    },
    setSelectedEventId(state, selectedEventId){
      state.selectedEventId = selectedEventId;
    },
    setListOfFavourites(state, listOfFavourites){
      state.listOfFavourites = listOfFavourites;
    },
    setSaveFavourite(state, saveFavourite){
      state.saveFavourite = saveFavourite;
    },
    setAdminData(state, adminData){
      state.adminData = adminData;
    },
    setBookingData(state, bookingData){

      state.bookingData = bookingData;
    },
    setGoToPartnerAccount(state, goToPartnerAccount){
      state.goToPartnerAccount = goToPartnerAccount;
    },
    setCurrentScrollPos(state, currentScrollPos){
      state.currentScrollPos = currentScrollPos;
    },
    setUserIsCreatingPassport(state, userIsCreatingPassport){
      state.userIsCreatingPassport = userIsCreatingPassport;
    },
    setRefForHomepage(state, refForHomepage) {
      state.refForHomepage = refForHomepage;
    },
    setUserOrderLon(state, userOrderLon) {
      state.userOrderLon = userOrderLon;
    },
    setUserOrderLat(state, userOrderLat) {
      state.userOrderLat = userOrderLat;
    },
    setThemes(state, themes) {
      state.themes = themes;
    },
    setRememberAccountPassword(state, rememberAccountPassword){
      state.rememberAccountPassword = rememberAccountPassword;
    },
    setFiltersForEvent(state, filtersForEvent){
      state.filtersForEvent = filtersForEvent;
    },
    setCalendar(state, calendar){
      state.calendar = calendar;
    },
    setNoBackground(state, noBackground){
      state.noBackground = noBackground;
    },
    setUserTripOverviewOrderList(state, orderList){
      state.userTripOverview.orderList = orderList;
    },
    setUserTripOverview(state, userTripOverview){
      state.userTripOverview = userTripOverview;
    },
    setEventDetailsSaved(state, eventDetailsSaved){
      state.eventDetailsSaved = eventDetailsSaved;
    },
    setThemeListEventId(state, themeListEventId){
      state.themeListEventId = themeListEventId;
    },
    setChosenLocationId(state, chosenLocationId){
      state.chosenLocationId = chosenLocationId;
    },
    setABCMapMarker(state, ABCMapMarker){
      state.ABCMapMarker = ABCMapMarker;
    },
    setCategorieMarkers(state, CategorieMarkers){
      state.CategorieMarkers = CategorieMarkers;
    },
    setActivitiesMarker(state, ActivitiesMarker){
      state.ActivitiesMarker = ActivitiesMarker;
    },
    setDrinkingMarker(state, DrinkingMarker){
      state.DrinkingMarker = DrinkingMarker;
    },
    setEatingMarker(state, EatingMarker){
      state.EatingMarker = EatingMarker;
    },
    setMapMarkerPin(state, mapMarkerPin){
      state.mapMarkerPin = mapMarkerPin;
    },
    setRoutes(state, allRoutes) {
      state.allRoutes = allRoutes;
    },
    setUserLocations(state, userLocations) {
      state.userLocations = userLocations;
    },
    setNoBackendConnection(state, noBackendConnection) {
      state.noBackendConnection = noBackendConnection;
    },
    setCurrentEventId(state, currentEventId) {
      state.currentEventId = currentEventId;
    },
    setSavePartnerId(state, savePartnerId) {
      state.savePartnerId = savePartnerId;
    },
    setChosenEvent(state, chosenEvent) {
      state.chosenEvent = chosenEvent;
    },
    setRedirectedFromPearlCalendar(state, redirectedFromPearlCalendar) {
      state.redirectedFromPearlCalendar = redirectedFromPearlCalendar;
    },
    setVisitorActive(state, visitorActive) {
      state.visitorActive = visitorActive;
    },
    setPartnerIdForLink(state, partnerIdForLink) {
      state.partnerIdForLink = partnerIdForLink;
    },
    set(state, chosenLocationId) {
      state.chosenLocationId = chosenLocationId;
    },
    setUserNotInFlag(state, userNotInAccount) {
      state.userNotInAccount = userNotInAccount;
    },
    setCurrentComponent(state, currentComponent) {
      state.currentComponent = currentComponent;
    },
    setCurrentMainComponent(state, currentMainComponent) {
      state.currentMainComponent = currentMainComponent;
    },
    setUserGroupsForAccount(state, userGroupsForAccount) {
      state.userGroupsForAccount = userGroupsForAccount;
    },
    setOperationalScreenSize(state, operationalScreenSize) {
      state.operationalScreenSize = operationalScreenSize
    },
    setTabIdAccountManagement(state, tabIdAccountManagement) {
      state.tabIdAccountManagement = tabIdAccountManagement
    },
    setCurrentAccountId(state, currentAccountId) {
      state.currentAccountId = currentAccountId;
    },
    setCurrentUserGroupId(state, currentUserGroupId) {
      state.currentUserGroupId = currentUserGroupId;
    },
    setDiscountCards(state, discountCards) {
      state.discountCards = discountCards;
    },
    setUserCalendarCache(state, userCalendarCache) {
      state.userCalendarCache = userCalendarCache;
    },
    setAccountInfo(state, AccountInfo) {
      state.AccountInfo = AccountInfo;
    },
    setAccountVat(state, AccountVat) {
      state.AccountVat = AccountVat;
    },
    setCustomerPreferencesObjects(state, customerPreferencesObjects) {
      state.customerPreferencesObjects = customerPreferencesObjects;
    },
    setCustomerPreferences(state, customerPreferences) {
      state.customerPreferences = customerPreferences;
    },
    setBackgroundImage(state, Background_image) {
      state.Background_image = Background_image;
    },
    setTripForm(state, tripForm) {
      state.tripForm = tripForm;
    },
    setTripFormActivities(state, activities) {
      state.tripForm.activities = activities;
    },
    setTripFormEventId(state, mainEventId) {
      state.tripForm.mainEventId = mainEventId;
    },
    setTripFormEventName(state, eventName) {
      state.tripForm.eventName = eventName;
    },
    setTripFormStartDate(state, startDate) {
      state.tripForm.ArrivalDate = startDate;
    },
    setTripFormEndDate(state, endDate) {
      state.tripForm.DepartureDate = endDate;
    },
    setTripFormIgnoreWarning(state, ignoreWarning) {
      state.tripForm.ignoreWarning = ignoreWarning;
    },
    setTripFormSpecialCode(state, specialCode) {
      state.tripForm.specialCode = specialCode;
    },
    setTripFormPaymentId(state, paymentId) {
      state.tripForm.paymentId = paymentId;
    },
    setTripFormGroupSize(state, groupSize) {
      state.tripForm.groupSize = groupSize;
    },
    setTripFormArrivalTime(state, ArrivalTime) {
      state.tripForm.ArrivalTime = ArrivalTime;
    },
    setTripFormDepartureTime(state, DepartureTime){
      state.tripForm.DepartureTime = DepartureTime;
    },
    setTripFormOrderId(state, orderId) {
      state.tripForm.orderId = orderId;
    },
    setTripFormTripId(state, tripId) {
      state.tripForm.tripId = tripId;
    },
    setTripFormActivityList(state, activityList) {
      state.tripForm.activityList = activityList;
    },
    setTripFormLocationId(state, locationId) {
      state.tripForm.locationId = locationId;
    },
    setTripFormOrderEvents(state, orderEvents) {
      state.tripForm.orderEvents = orderEvents;
    },
    setTripFormTotalPrice(state, totalPrice) {
      state.tripForm.totalPrice = totalPrice;
    },
    setTripFormChosenActivities(state, chosenActivities) {
      state.tripForm.chosenActivities = chosenActivities;
    },
    setTripFormTransportId(state, transportId) {
      state.tripForm.transportId = transportId;
    },
    setTripFormTransportName(state, transportName) {
      state.tripForm.transportName = transportName;
    },
    setTripFormChosenChildren(state, chosenChildren) {
      state.tripForm.chosenChildren = chosenChildren;
    },
    setTripFormChosenTheme(state, chosenTheme) {
      state.tripForm.chosenTheme = chosenTheme;
    },
    setTripFormIssueList(state, issueList) {
      state.tripForm.issueList = issueList;
    },
    setTripFormPlannedList(state, plannedList) {
      state.tripForm.plannedList = plannedList;
    },
    setFiltersLocation(state, filtersLocation) {
      state.filtersLocation = filtersLocation;
    },
    setAllTags(state, allTags) {
      state.allTags = allTags;
    },
    setSelectedPartOfLocation(state, selectedPartOfLocation) {
      state.selectedPartOfLocation = selectedPartOfLocation
    },
    setSortLocationOrder(state, sort) {
      state.sortLocationOrder = sort
    },
    setEvents(state, events) {
      state.events = events;
    },
    setLocations(state, locations) {
      locationsModule.setLocations(locations);
    },
    toggleEvent(state, eventId) {
      let index = state.selectedEvents.indexOf(eventId);

      if (index !== -1) {
        state.selectedEvents.splice(index, 1);
      } else {
        state.selectedEvents.push(eventId);
      }
    },
    setLanguage(state, language) {
      state.language = language;
    },
    setUserLanguage(state, userLanguage) {
      state.userLanguage = userLanguage;
    },
    setLanguages(state, languages) {
      state.languages = [];
      state.languages = [...languages];
    },
    setMobilePhoneActive(state, mobilePhoneActive) {
      state.mobilePhoneActive = mobilePhoneActive;
    },
    toggleSubEvent(state, subEventId) {
      let index = state.selectSubEvents.indexOf(subEventId);

      if (index !== -1) {
        state.selectSubEvents.splice(index, 1);
      } else {
        state.selectSubEvents.push(subEventId);
      }
    },

    increment(state) {
      state.count++;
    },
    setStepId(state, stepId) {
      state.stepId = stepId;
      // state.stepId.push(stepId);
    },
    setWebStepId(state, webStepId) {
      state.webStepId = webStepId;
      // state.webStepId.push(webStepId);
    },
    setPaymentId(state, paymentId) {
      state.paymentId = paymentId;
    },
    setArrivalInfo(state, payload) {
      // delete payload.datatype
      state.arrivalInfo = payload;
    },
    setEventData(state, payload) {
      delete payload.datatype;
      state.eventData = payload;
    },

    setSubEventData(state, payload) {
      state.subEventData = payload;
    },
    setSubEventSelected(state, payload) {
      state.subEventSelected = payload;
    },
    setOrderId(state, orderId) {
      state.orderId = orderId;
    },
    setOrderDetails(state, orderDetails) {
      state.orderDetails = orderDetails
    },
    setTotalPrice(state, totalPrice) {
      state.totalPrice = totalPrice;
    },
    setOrderBill(state, payload) {
      state.orderBill = payload;
    },
    setMainEventSelected(state, mainSelected) {
      state.mainSelected = mainSelected;
    },
    setUserEventArrivalData(state, payload) {
      state.userEventArrivalData = payload;
    },
    storeCategories(state, payload) {
      state.categories = payload;
    },
    setSelectedNotification(state, item) {
      state.selectedNotification = item;
    },
    setMainEventClickedValue(state, mainEventId) {
      let index = state.subEventData.findIndex(
        i => i.MainEventText === mainEventId
      );
      state.subEventData[index].Clicked = !state.subEventData[index].Clicked;
    },
    setMainEventSubClickedValue(state, mainEventId) {
      let index = state.subEventData.findIndex(
        i => i.MainEventText === mainEventId
      );
      state.subEventData[index].SubClicked = !state.subEventData[index]
        .SubClicked;
    },
    setSubEventClickedValue(state, payload) {
      let index = state.subEventData.findIndex(
        i => i.MainEventText === payload[0].MainEventId
      );
      let key = state.subEventData[index]["SubEvents"].findIndex(
        j => j.SubEventId === payload[0].SubEventId
      );
      state.subEventData[index]["SubEvents"][key].Clicked = !state.subEventData[
        index
      ]["SubEvents"][key].Clicked;
    },
    setUserName(state, userName) {
      auth.setUserName(userName);
    },
    setUserGroups(state, userGroups) {
      auth.setUserGroups(userGroups);
    },
    setTokenType(state, tokenType) {
      auth.setTokenType(type);
    },
    setUserLevel(state, userLevel) {
      auth.setUserLevel(userLevel);
    },
    setPartnerId(state, partnerId) {
      auth.setPartnerId(partnerId);
    },
    setTmpPartnerAdmin (state, tmpPartnerAdmin) {
      auth.setTmpPartnerAdmin(tmpPartnerAdmin);
    },
    setToken(state, token) {
      auth.setToken(token);
      // state.token = token;
      // state.logedIn = true;
    },
    unSetToken(state) {
      state.token = "";
      // state.logedIn = false;
    },

    setRightClickBehaviour(state, behaviour) {
      state.behaviour = behaviour;
    },

    addIncident(state, { obj, id }) {
      let indexOf = state.incidents.findIndex(
        element => element.get("id") === id
      );
      if (indexOf === -1) {
        state.incidents.push(obj);
      } else {
        state.incidents[indexOf] = obj;
      }
    },
    removeIncident(state, id) {
      let indexOf = state.incidents.findIndex(
        element => element.get("id") === id
      );
      if (indexOf !== -1) {
        state.incidents.splice(indexOf, 1);
      }
    },
    addAnomaly(state, { obj, id }) {
      let indexOf = state.anomalies.findIndex(
        element => element.get("id") === id
      );
      if (indexOf === -1) {
        state.anomalies.push(obj);
      } else {
        state.anomalies[indexOf] = obj;
      }
    },
    setSelectedLocation(state, location) {
      state.location = location;
    },
    setDashboardStatus(state, status) {
      state.dashboardStatus = status;
    },
    setDragElement(state, draggedElement) {
      state.draggedElement = draggedElement;
    },
    setAllObjectFromTree(state, allObjectList) {
      state.allObjectList = allObjectList;
    },
    setRelationList(state, relationList) {
      state.relationList = relationList;
    },
    setFilterTags(state, filtersTags) {
      state.filtersTags = filtersTags;
    },
    setFilterName(state, filterName) {
      state.filterName = filterName;
    },
    setEventFilterName(state, eventFilterName) {
      state.eventFilterName = eventFilterName;
    },
    setSelectedItem(state, selectedItem) {
      state.selectedItem = selectedItem;
    },
    setStatusTags(state, elements) {
      if (elements != null) {
        for (const [k, v] of Object.entries(elements)) {
          // k is the Group name
          let group = state.filtersTags.filter(e => e.title === k);
          if (group.length > 0) {
            group[0].entries.forEach(i => {
              i.status = false;
            });
            for (const k1 of Object.keys(v)) {
              group[0].entries.forEach(i => {
                if (Number(i.k) == k1) {
                  i.status = true;
                }
              });

            }
          }
        }
      } else {
        // set all filters tags to false
        state.filtersTags.forEach(e => {
          e.status = false;
          e.entries.forEach(e1 => {
            e1.status = false;
          })
        })
      }
    },
    setStatusTag(state, element) {
      state.filtersTags.forEach(e => {
        if (e.title == element.group) {
          e.entries.forEach(i => {
            if (i.v == element.v) {
              i.status = !i.status;
            }
          });
        }
      });
    },
    setUserRolesFromUserGroup(state, UserRoles) {
      state.UserRolesFromUserGroup = UserRoles;
    }
  },
  actions: {
    setStepId({ commit }, stepId) {
      commit("setStepId", stepId);
    },
    setOrderDetails({ commit }, orderDetail) {
      commit("setOrderDetails"), orderDetail
    },
    setPaymentId({ commit }, paymentId) {
      commit("setPaymentId", paymentId);
    },
    setEventData({ commit }, payload) {
      commit("setEventData", payload);
    },

    setSubEventData({ commit }, payload) {
      commit("setSubEventData", payload);
    },
    setSubEventSelected({ commit }, payload) {
      commit("setSubEventSelected", payload);
    },
    setMainEventSelected({ commit }, mainSelected) {
      commit("setMainEventSelected", mainSelected);
    },
    setOrderId({ commit }, orderId) {
      commit("setOrderId", orderId);
    },
    setTotalPrice({ commit }, totalPrice) {
      commit("setTotalPrice", totalPrice);
    },
    setOrderBill({ commit }, payload) {
      commit("setOrderBill", payload);
    },
    setUserEventArrivalData({ commit }, payload) {
      commit("setUserEventArrivalData", payload);
    },
    storeCategories({ commit }, payload) {
      commit("storeCategories", payload);
    },
    setSelectedNotification({ commit }, item) {
      commit("setSelectedNotification", item);
    },
    setSelectedLocation({ commit }, location) {
      commit("setSelectedLocation", location);
    },
    setAllObjectFromTree({ commit }, allObjectList) {
      commit("setAllObjectFromTree", allObjectList);
    },
    setRelationList({ commit }, relationList) {
      commit("setRelationList", relationList);
    },
    setConfAndValidateObjId({ commit }, confAndValidateObjId) {
      commit("setConfAndValidateObjId", confAndValidateObjId);
    }
  },
  getters: {
    getParentEventId(state){
      return state.parentEventId;
    },
    getEventIdForCalendar(state){
      return state.eventIdForProductCalendar;
    },
    getProductIdForCalendar(state){
      return state.productIdForProductCalendar;
    },
    getMainLocationId(state){
      return state.mainLocationId;
    },
    getFiltersForMap(state){
      return state.filtersForMap;
    },
    getNewLocationList(state){
      return state.newLocationList;
    },
    getGoToAfterLoginOrRegister(state){
      return state.goToAfterLoginOrRegister;
    },
    getCenterPointForMap(state){
      return state.centerPointForMap;
    },
    getRouteEvents(state){
      return state.routeEvents;
    },
    getCalendarOnHomePage(state){
      return state.calendarOnHomePage;
    },
    getUserIsInQuadrantScreen(state){
      return state.userIsInQuadrantScreen;
    },
    getBackupDataForRouteAspect(state){
      return state.backupDataForRouteAspect;
    },
    getUserIsCreatingEvent(state){
      return state.userIsCreatingEvent;
    },
    getAllVisibleLocations(state){
      return state.allVisibleLocations;
    },
    getMainLocationAspects(state){
      return state.mainLocationAspects;
    },
    getUserIsCrowdScout(state){
      return state.userIsCrowdScout;
    },
    getTitleOfMap(state){
      return state.titleOfMap;
    },
    getTimeMarkers(state){
      return state.timeMarkers;
    },
    getDeliverMarkers(state){
      return state.deliverMarkers;
    },
    getAllDelivers(state){
      return state.allDelivers;
    },
    getUserActivationObject(state){
      return state.userActivationObject;
    },
    getUserActivatedSuccessfull(state){
      return state.userActivatedSuccessfull;
    },
    getTours(state){
      return state.tours;
    },
    getEventSave(state){
     return state.eventSave;
    },
    getSelectedTheme(state) {
      return state.selectedTheme;
    },
    getUserGoesBackToHomepage(state) {
      return state.userGoesBackToHomepage;
    },
    getPartnerCreate(state) {
      return state.partnerCreate;
    },
    getSeeMapInOprMapQua(state) {
      return state.seeMapInOprMapQua;
    },
    getShoppingCart(state) {
      return state.shoppingCart;
    },
    getCalendarIsEmpty(state) {
      return state.calendarIsEmpty;
    },
    getClickedOnPasspoortButton(state) {
      return state.clickedOnPasspoortButton;
    },
    getRegion(state) {
      return state.region;
    },
    getRedirectedFromWebToEvent(state){
      return state.redirectedFromWebToEvent;
    },
    getAddUserAccommodations(state){
      return state.addUserAccommodations;
    },
    getQrCodeScanner(state){
      return state.qrCodeScanner;
    },
    getstampsDialog(state){
      return state.stampsDialog;
    },
    getAmountEuros(state){
      return state.amountEuros;
    },
    getBrowserType(state){
      return state.browserType;
    },
    getShowButton(state){
      return state.showButton;
    },
    getClickedTime(state){
      return state.clickedTime;
    },
    getLocationsOfUserTripList(state){
      return state.locationsOfUserTripList;
    },
    getLocationDetails(state){
      return state.locationDetails;
    },
    getSelectedEventId(state){
      return state.selectedEventId;
    },
    getListOfFavourites(state){
      return state.listOfFavourites;
    },
    getSaveFavourite(state){
      return state.saveFavourite;
    },
    getAdminData(state){
      return state.adminData;
    },
    getBookingData(state){
      return state.bookingData;
    },
    getGoToPartnerAccount(state){
      return state.goToPartnerAccount;
    },
    getCurrentScrollPos(state){
      return state.currentScrollPos;
    },
    getRefForHomepage(state) {
      return state.refForHomepage;
    },
    getUserOrderLon(state) {
      return state.userOrderLon;
    },
    getUserOrderLat(state) {
      return state.userOrderLat;
    },
    getThemes(state) {
      return state.themes;
    },
    getUserIsCreatingPassport(state){
      return state.userIsCreatingPassport;
    },
    getRememberAccountPassword(state){
      return state.rememberAccountPassword;
    },
    getFiltersForEvent(state){
      return state.filtersForEvent;
    },
    getCalendar(state){
      return state.calendar;
    },
    getNoBackground(state){
      return state.noBackground;
    },
    getUserTripOverviewOrderList(state){
      return state.userTripOverview.orderList;
    },
    getUserTripOverview(state){
      return state.userTripOverview;
    },
    getEventDetailsSaved(state){
      return state.eventDetailsSaved;
    },
    getThemeListEventId(state){
      return state.themeListEventId;
    },
    getABCMapMarker(state){
      return state.ABCMapMarker;
    },
    getCategorieMarkers(state){
      return state.CategorieMarkers;
    },
    getActivitiesMarker(state){
      return state.ActivitiesMarker;
    },
    getDrinkingMarker(state){
      return state.DrinkingMarker;
    },
    getEatingMarker(state){
      return state.EatingMarker;
    },
    getMapMarkerPin(state){
      return state.mapMarkerPin;
    },
    getChosenLocationId(state){
      return state.chosenLocationId;
    },
    getNoBackendConnection(state) {
      return state.noBackendConnection;
    },
    getUserCalendarCache(state) {
      return state.userCalendarCache;
    },
    getSavePartnerId(state) {
      return state.savePartnerId;
    },
    getChosenEvent(state) {
      return state.chosenEvent;
    },
    getRedirectedFromPearlCalendar(state) {
      return state.redirectedFromPearlCalendar;
    },
    getVisitorActive(state) {
      return state.visitorActive;
    },
    getPartnerIdForLink(state) {
      return state.partnerIdForLink;
    },
    getOrderDetails(state, orderDetails) {
      return state.orderDetails
    },
    getStepId(state) {
      return state.stepId;
    },
    getWebStepId(state) {
      return state.webStepId;
    },
    getPaymentId(state) {
      return state.paymentId;
    },
    getEventData(state) {
      return state.eventData;
    },
    getArrivalInfo(state) {
      return state.arrivalInfo;
    },
    getQuadrantEvent(state) {
      return state.quadrantEvent;
    },
    getEnlargedQuadrant(state) {
      return state.enlargedQuadrant;
    },
    getADS(state){
      return state.ADS;
    },
    getMAS(state){
      return state.MAS;
    },
    getSubEventData(state) {
      return state.subEventData;
    },
    getSubSelected(state) {
      return state.subEventSelected;
    },
    getOrderId(state) {
      return state.orderId;
    },
    getTotalPrice(state) {
      return state.totalPrice;
    },
    getOrderBill(state) {
      return state.orderBill;
    },
    getMainEventSelected(state) {
      return state.mainSelected;
    },
    getUserEventArrivalData(state) {
      return state.userEventArrivalData;
    },
    getLanguage(state) {
      return state.language;
    },
    getUserLanguage(state) {
      return state.userLanguage;
    },
    getLanguages(state) {
      return state.languages;
    },
    getMobilePhoneActive(state) {
      return state.mobilePhoneActive;
    },
    getCategories(state) {
      return state.categories;
    },
    getUserNotInFlag(state) {
      return state.userNotInAccount;
    },
    getChosenLocationId(state) {
      return state.chosenLocationId;
    },
    getSelectedDate(state) {
      return state.selectedDate;
    },
    getRoutes(state) {
      return state.allRoutes;
    },
    getUserLocations(state) {
      return state.userLocations;
    },
    getCurrentEventId(state) {
      return state.currentEventId;
    },
    getSelectedNotification(state) {
      return state.selectedNotification;
    },
    getRightClickBehaviour(state) {
      return state.behaviour;
    },
    getIncidents(state) {
      return state.incidents;
    },
    getAnomalies(state) {
      return state.anomalies;
    },

    getAspectsListRequested(state) {
      return state.aspectsListRequested;
    },

    getIncidentsById: state => id => {
      // return state.incidentsMap.get(id);
      return state.incidents.find(element => element.get("id") === id);
    },
    getDragStatus(state) {
      return state.dragStatus;
    },
    getDashboardStatus(state) {
      return state.dashboardStatus;
    },
    getDraggedElement(state) {
      return state.draggedElement;
    },
    getAllObjectList(state, allObjectList) {
      return state.allObjectList;
    },
    getRelationList(state, relationList) {
      return state.relationList;
    },
    getFilterTags(state, filtersTags) {
      return state.filtersTags;
    },
    getFilterName(state, filterName) {
      return state.filterName;
    },
    getEventFilterName(state, eventFilterName) {
      return state.eventFilterName;
    },
    getSelectedItem(state, selectedItem) {
      return state.selectedItem;
    },
    getEvents(state, events) {
      return state.events;
    },
    getSortLocationOrder(state, sortLocationOrder) {
      return state.sortLocationOrder;
    },
    getSelectedPartOfLocation(state, selectedPartOfLocation) {
      return state.selectedPartOfLocation;
    },
    getAllTags(state, allTags) {
      return state.allTags;
    },
    getFiltersLocation(state, filtersLocation) {
      return state.filtersLocation;
    },
    getTripForm(state) {
      return state.tripForm;
    },
    getDepartureTime(state) {
      return state.DepartureTime;
    },
    getBackGroundImage(state) {
      if (state.Background_image !== '') {
        return state.Background_image;
      } else {
        state.Background_image = "Error";
        return state.Background_image;
        }
    },
    getCustomerPreferencesHeaderLogo(state) {
      return state.customerPreferences.Header_logo;
    },
    getActivitiesForLocation(state){
      return state.activitiesForLocation;
    },
    getCustomerPreferencesMobilePhoto(state) {
      return state.customerPreferences.mobile_image;
    },
    getCustomerPreferences(state) {
      return state.customerPreferences;
    },
    getCustomerPreferencesObjects(state) {
      return state.customerPreferencesObjects;
    },
    getAccountId(state) {
      return state.AccountInfo.AccountId;
    },
    getAccountInfo(state) {
      return state.AccountInfo;
    },
    getAccountVat(state) {
      return state.AccountVat;
    },
    getDiscountCards(state) {
      return state.discountCards;
    },
    getCurrentUserGroupId(state) {
      return state.currentUserGroupId;
    },
    getCurrentAccountId(state) {
      return state.currentAccountId;
    },
    getTabIdAccountManagement(state, tabIdAccountManagement) {
      return state.tabIdAccountManagement;
    },
    getOperationalScreenSize(state, operationalScreenSize) {
      return state.operationalScreenSize;
    },
    getUserGroupsForAccount(state, userGroupsForAccount) {
      return state.userGroupsForAccount;
    },
    getCurrentComponent(state, currentComponent) {
      return state.currentComponent;
    },
    getCurrentMainComponent(state, currentMainComponent) {
      return state.currentMainComponent;
    },
    getTripFormChosenTheme(state) {
      return state.tripForm.chosenTheme;
    },
    getTripFormIssueList(state) {
      return state.tripForm.issueList;
    },
    getTripFormPlannedList(state) {
      return state.tripForm.plannedList;
    },
    getTripFormGroupSize(state) {
      return state.tripForm.groupSize;
    },
    getUserRolesFromUserGroup(state) {
      return state.UserRolesFromUserGroup;
    }
  }
});
